import React from 'react'
import intl from 'react-intl-universal'
import styled from 'styled-components'
import { Button } from '@raysync/common/components'
import { Navigation } from '@raysync/common/services'
import { Devices } from '@raysync/common/theme'
const SlideWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 56px;
  @media ${Devices.phone} {
    height: auto;
    margin-top: 0.6rem;
  }
`

const SlideItem = styled.div`
  display: flex;
  height: 440px;
  width: 1400px;
  box-shadow: 0px 0px 30px 0px #e2e7ec;
  border-radius: 20px;
  @media ${Devices.phone} {
    flex-wrap: wrap;
    width: 100%%;
    height: auto;
  }
`

const SlideImage = styled.img`
  width: 50%;
  height: 100%;
  background: #d8dfe3;
  object-fit: cover;
  @media ${Devices.phone} {
    width: 100%;
    height: 2.5rem;
  }
`

const SlideContent = styled.div`
  height: 100%;
  width: 50%;
  background: #fff;
  padding: 50px 44px;
  line-height: 1.5;
  @media ${Devices.phone} {
    width: 100%;
    padding: 0.5rem 0.4rem;
    height: fit-content;
  }
`

const SlideTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 24px;
  color: ${p => p.theme.color.textDarkPlus};
  @media ${Devices.phone} {
    font-size: 0.3rem;
    margin-bottom: 0.24rem;
  }
`

const SlideDesc = styled.p`
  font-size: 16px;
  margin-bottom: 30px;
  color: #636772;
  @media ${Devices.phone} {
    font-size: 0.2rem;
    margin-bottom: 0.3rem;
  }
`

// const SlideArrow = styled.div`
//   z-index: 1;
//   cursor: pointer;
//   width: 60px;
//   height: 60px;
//   background: #e6edf1;
//   border-radius: 50%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   @media ${Devices.phone} {
//     width: 0.6rem;
//     height: 0.6rem;
//     display: none;
//   }
// `

// const ArrowIcon = styled.i`
//   border: solid ${p => p.theme.color.textDarkPlus};
//   border-width: 0 3px 3px 0;
//   display: inline-block;
//   padding: 3px;
//   transform: ${props => (props.direction === 'right' ? 'rotate(-45deg)' : 'rotate(135deg)')};
// `

const Slide = ({ items }) => {
  // const [currentSlide, setCurrentSlide] = useState(0)

  // const handleClick = newSlide => {
  //   setCurrentSlide(newSlide)
  // }

  // const handlePrev = () => {
  //   const newSlide = currentSlide === 0 ? items.length - 1 : currentSlide - 1
  //   handleClick(newSlide)
  // }

  // const handleNext = () => {
  //   const newSlide = currentSlide === items.length - 1 ? 0 : currentSlide + 1
  //   handleClick(newSlide)
  // }

  return (
    <SlideWrapper>
      {items.map((item, index) => (
        <SlideItem key={index}>
          <SlideImage src={item.image} alt={item.title} />
          <SlideContent>
            <SlideTitle>{item.title}</SlideTitle>
            <SlideDesc>{item.desc}</SlideDesc>
            <Button
              onClick={() => {
                Navigation.to({
                  link:
                    '/casestudies/renderbus-accelerates-cross-border-file-transfer-with-raysync-sdk-integrated-solution/',
                })
              }}
            >
              {intl.get('home.banner2.button')}
            </Button>
          </SlideContent>
        </SlideItem>
      ))}
    </SlideWrapper>
  )
}

export default Slide
